import React from 'react'
import { Link } from '@inertiajs/react'
import styles from './NavLink.module.scss'

interface NavLinkProps {
  href: string
  active?: boolean
  children: React.ReactNode
  className?: never
}

export const NavLink: React.FC<NavLinkProps> = ({ href, active = false, children }) => (
  <Link
    href={href}
    className={[styles.link, active ? styles.active : styles.inactive].join(' ')}
  >
    {children}
  </Link>
)
